import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';
import { SortOrders } from '../../enums/sort-orders.enum';
import { Sorter } from '@macs-frontend/features/shared/models/sorter';

@Component({
  selector: 'md-table-sorter',
  templateUrl: 'table-sorter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableSorterComponent extends BaseComponent {
  SortOrders = SortOrders;

  @Input() currentSorter: Sorter | null = null;

  @Input() sortBy = '';

  @Output() sort = new EventEmitter<Sorter>();

  constructor(readonly cdr: ChangeDetectorRef) {
    super();
  }

  onSort() {
    let order = SortOrders.ASC;
    if (this.currentSorter?.by === this.sortBy) {
      order =
        this.currentSorter?.order === SortOrders.ASC ? SortOrders.DESC : SortOrders.ASC;
    }
    this.sort.emit({
      by: this.sortBy,
      order,
    });
  }

  get active() {
    return this.currentSorter?.by === this.sortBy;
  }

  get ascOrder() {
    return this.currentSorter?.order === SortOrders.ASC;
  }
}
